import { useTranslation } from 'react-i18next'
import { ConfirmModal } from '@/components/modal'
import { APP_CUSTOM_ERROR } from '@/constants/MessageConstants'
import { Match } from '@/types'
import { useDeleteMatch } from '@/services'
import toast from 'react-hot-toast'
import { useContext } from 'react'
import { matchesContext } from './MatchesContext'

type RejectMatchModalProps = {
  match: Match
  open: boolean
  onClose: () => void
}

export function RejectMatchModal({ match, open, onClose }: RejectMatchModalProps) {
  const { t } = useTranslation()
  const { mutate: rejectMatch } = useDeleteMatch()
  const { setMatches, setOffset, matches } = useContext(matchesContext)

  const extractErr = (err: unknown) => {
    if (
      typeof err === 'object' &&
      err !== null &&
      'response' in err &&
      typeof (err as { response?: { data?: { message?: string } } }).response?.data?.message === 'string'
    ) {
      return (err as { response: { data: { message: string } } }).response.data.message
    }
    return APP_CUSTOM_ERROR
  }

  const handleSubmit = () => {
    rejectMatch(match.id, {
      onSuccess: () => {
        if (setMatches && setOffset && matches !== null) {
          const idx = matches.indexOf(match)
          if (idx > -1) {
            const next = [...matches]
            next.splice(idx, 1)
            setMatches(next)
            setOffset((prev) => prev - 1)
          }
        }
        onClose()
      },
      onError: (err: unknown) => toast.error(extractErr(err)),
    })
  }

  return (
    <ConfirmModal
      open={open}
      onSubmit={handleSubmit}
      onClose={onClose}
      title={`${t('common.deleteMatch')}?`}
      desc={t('performance.deleteMatchConfirm')}
      cancelTitle={t('common.goBack')}
      submitTitle={t('common.delete')}
      submitButtonClassName="!bg-boldOrange hover:!opacity-70"
      closeButtonClassName="text-sm"
    />
  )
}
